import type { TanstackDatabaseStorageConfig } from "@/domains/tanstack-db/core/storage-kind";
import {
  createSmartContextLocalCollection,
  type SmartContextsCollection,
} from "./smart-contexts/index";
import { createSmartViewLocalCollection, type SmartViewsCollection } from "./smart-views/index";
import { createSmartCardLocalCollection, type SmartCardsCollection } from "./smart-cards/index";
import { getDefaultTanstackStorage, assertSupportedTanstackStorage } from "../storage-kind";

export interface CreateTanstackCollectionsOptions {
  storage?: TanstackDatabaseStorageConfig;
}

export interface TanstackDatabaseCollections {
  smartContexts: SmartContextsCollection;
  smartViews: SmartViewsCollection;
  smartCards: SmartCardsCollection;
}

export const createTanstackCollections = ({
  storage = getDefaultTanstackStorage(),
}: CreateTanstackCollectionsOptions = {}): TanstackDatabaseCollections => {
  assertSupportedTanstackStorage(storage);

  return {
    smartContexts: createSmartContextLocalCollection(),
    smartViews: createSmartViewLocalCollection(),
    smartCards: createSmartCardLocalCollection(),
  };
};
